import api from './index';
import { fetchReadableStream } from './fetchReadableStream';

const BASE = '/forecastDelta';

interface ForecastDeltaTotals {
    positive: number;
    negative: number;
}

interface ForecastDeltaByDate {
    slotDate: string;
    forecastDeltas: number;
}

export const uploadForecast = async ({
    dataToUpload,
    monthForUploading,
    setPercentage,
}: {
    dataToUpload: unknown;
    monthForUploading: string;
    setPercentage: (percentage: number) => void;
}) => {
    return await fetchReadableStream(`${BASE}`, { data: dataToUpload, monthForUploading }, setPercentage);
};

export const getTotalForecastDeltaValuesByDateRangeAndWorktype = async (
    dateFrom: string,
    dateTo: string,
    worktype: number
): Promise<{ totalForecastDeltas: ForecastDeltaTotals }> => {
    return api
        .get(`${BASE}/getTotalForecastDeltaValuesByDateRangeAndWorktype`, { params: { dateFrom, dateTo, worktype } })
        .then((res) => res.data);
};

export const getAllForecastDeltasByDateRangeAndWorktype = async (
    dateFrom: string,
    dateTo: string,
    worktype: number
): Promise<ForecastDeltaByDate[]> => {
    return api
        .get(`${BASE}/getAllForecastDeltasByDateRangeAndWorktype`, { params: { dateFrom, dateTo, worktype } })
        .then((res) => res.data);
};

export const getSumOfAllForecastDeltaValuesByDateRangeWorktypeAndLocation = async (
    dateFrom: string,
    dateTo: string,
    worktype: number,
    location: number
): Promise<ForecastDeltaTotals> => {
    return api
        .get(`${BASE}/getSumOfAllForecastDeltaValuesByDateRangeWorktypeAndLocation`, {
            params: { dateFrom, dateTo, worktype, location },
        })
        .then((res) => res.data);
};

export const getAllForecastDeltasByDateRangeWorktypeAndLocation = async (
    dateFrom: string,
    dateTo: string,
    worktype: number,
    location: number
): Promise<ForecastDeltaByDate[]> => {
    return api
        .get(`${BASE}/getAllForecastDeltasByDateRangeWorktypeAndLocation`, {
            params: { dateFrom, dateTo, worktype, location },
        })
        .then((res) => res.data);
};

export const getLastForecastDeltaUploadDate = async (worktype: number): Promise<string> => {
    return api.get(`${BASE}/lastUploadDate`, { params: { worktype } }).then((res) => res.data);
};
